import React, { useState, useEffect } from "react";

const WarehouseOccupancy = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchstatistics();
  }, []);

  const fetchstatistics = async () => {
    try {
      const response = await fetch("https://ambronex.in/apis/statistics_show.php", {
        method: "POST",
        body: new FormData(),
      });

      const result = await response.json();

      if (result.status === "success") {
        setData(result.data || []);
        setTotal(result.total || null);
        setError("");
      } else {
        setData([]);
        setTotal([]);
        setError(result.message || "No data found");
      }

    } catch (err) {
      console.error("Fetch Error:", err);
      setError("Failed to fetch warehouse data");
    }
  };

  const today = new Date().toLocaleDateString("en-GB");

  return (
    <div className="container my-5">
      {/* Title */}
      <div className="text-center mb-4" data-aos="fade-up">
        <h3 className="text-uppercase" >Tamil Nadu Warehousing Corporation Chennai - 32</h3>
        <h5 className="fw-bold mt-2">
          Warehouse Wise Occupancy Position As On {today}
        </h5>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No</th>
              <th>Location</th>
              <th>Total Capacity</th>
              <th>Occupancy</th>
              <th>Available</th>
              <th>Occupancy %</th>
              <th>Available %</th>
            </tr>
          </thead>
          <tbody className="table-light" >
            {data && data.length > 0 ? (
              data.map((warehouse, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{warehouse.wh_name}</td>
                  <td>{warehouse?.capacity_summary?.total_capacity}</td>
                  <td>{warehouse?.capacity_summary?.occupancy}</td>
                  <td>{warehouse?.capacity_summary?.available}</td>
                  <td>{warehouse?.capacity_summary?.occupancy_percentage} %</td>
                  <td>{warehouse?.capacity_summary?.available_percentage} %</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No warehouse data found
                </td>
              </tr>
            )}
          </tbody>
          {total && (
            <tfoot className="fw-bold" style={{ backgroundColor: "#3e4253ff" }} data-aos="zoom-up" data-aos-delay="400">
              <tr>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }} colSpan="2">
                  Total
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_capacity}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_occupancy}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_available}
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_occupancy_percentage} %
                </td>
                <td style={{ backgroundColor: "#3e4253ff", color: "white" }}>
                  {total.total_available_percentage} %
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default WarehouseOccupancy;